<template>
  <div class="layout--full-page house-importer-layout">
    <div class="house-importer-layout__header">
      <portal-target name="houseImporterPageTitle" class="house-importer-layout__page-title"/>

      <portal-target name="houseImporterHeaderCenter" class="house-importer-layout__header-center"/>


      <div class="house-importer-layout__logout house-importer-layout-logout" @click.stop="logout">
        <span class="house-importer-layout-logout__text">Выйти</span>
        <div class="house-importer-layout-logout__icon">
          <app-icon name="LogoutIcon" size="16px"/>
        </div>
      </div>
    </div>

    <div class="house-importer-layout__content">
      <router-view/>
    </div>
  </div>
</template>

<script>
  import oldColorsMixin from "../_mixins/oldColorsMixin";

  export default {
    name: "HouseImporterLayout",
    mixins: [oldColorsMixin],
    methods: {
      async logout() {
        await this.$store.dispatch('appUser/LOGOUT');
      }
    },
    beforeCreate() {
      document.body.classList.add('in-house-importer-layout');
      document.documentElement.classList.add('in-house-importer-layout');
    },
    beforeDestroy() {
      document.body.classList.remove('in-house-importer-layout');
      document.documentElement.classList.remove('in-house-importer-layout');
    }
  }
</script>

<style lang="scss">
  html.in-house-importer-layout {
    /*line-height: 1.2;*/
  }

  .house-importer-layout {
    min-height: 100vh;
    display: flex;
    flex-flow: column nowrap;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 15px 7.5px;
      flex-shrink: 0;
      height: 70px;
    }

    &__content {
      padding: 15px;
      flex-grow: 1;
      flex-shrink: 0;
      flex-basis: 100%;
    }

    &__page-title {
      font-size: 18px;
      font-weight: 700;
      width: 20%;
    }

    &__logout {
      width: 20%;
      justify-content: flex-end;
      /*margin-left: auto;*/
    }

    .content-full-page {
      height: calc(100vh - 110px);
    }
  }

  .house-importer-layout-logout {
    display: flex;
    align-items: center;
    cursor: pointer;

    &__text {
      line-height: 1;
    }

    &__icon {
      margin-left: 5px;
      display: flex;
      align-items: center;
      justify-content: center;

      svG {
        stroke: currentColor;
        stroke-width: 10;
      }
    }

    &:hover {
      color: rgba(var(--app-danger), 1);
    }
  }
</style>
